module.exports = __webpack_public_path__ + "static/media/app design (4).b32829e1.png";